import { ReactNode } from "react";

import {
  Code,
  Heading,
  Image,
  Link,
  OrderedList,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  UnorderedList,
} from "@chakra-ui/react";

import Li from "./CustomRenderers/Li";

export const overrides = {
  img: ({ src, alt }: { src: string; alt?: string }) => (
    <Image alt={alt} src={src} />
  ),
  a: ({ href, children }: { href: string; children: ReactNode }) => (
    <Link
      color="primary.500"
      href={href}
      rel="noopener noreferrer"
      target="_blank"
    >
      <Text overflow="hidden" color="inherit" textOverflow="ellipsis">
        {children}
      </Text>
    </Link>
  ),
  h1: ({ children }: { children: ReactNode }) => (
    <Heading as="h1" my={4} size="2xl">
      {children}
    </Heading>
  ),
  h2: ({ children }: { children: ReactNode }) => (
    <Heading as="h2" my={4} size="xl">
      {children}
    </Heading>
  ),
  h3: ({ children }: { children: ReactNode }) => (
    <Heading as="h3" my={4} size="lg">
      {children}
    </Heading>
  ),
  h4: ({ children }: { children: ReactNode }) => (
    <Heading as="h4" my={4} size="md">
      {children}
    </Heading>
  ),
  h5: ({ children }: { children: ReactNode }) => (
    <Heading as="h5" my={4} size="sm">
      {children}
    </Heading>
  ),
  h6: ({ children }: { children: ReactNode }) => (
    <Heading as="h6" my={4} size="xs">
      {children}
    </Heading>
  ),
  p: ({ children }: { children: ReactNode }) => (
    <Text color="textSecondary" size="body.md">
      {children}
    </Text>
  ),
  span: ({ children }: { children: ReactNode }) => (
    <Text color="textSecondary" overflowWrap={"anywhere"} size="body.md">
      {children}
    </Text>
  ),
  ol: OrderedList,
  ul: UnorderedList,
  li: Li,
  table: Table,
  thead: Thead,
  tbody: Tbody,
  code: Code,
  tr: Tr,
  th: Th,
  td: Td,
};
